import { render, staticRenderFns } from "./SentimentMarketCombined.vue?vue&type=template&id=611596b2&scoped=true"
import script from "./SentimentMarketCombined.vue?vue&type=script&lang=js"
export * from "./SentimentMarketCombined.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketCombined.vue?vue&type=style&index=0&id=611596b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611596b2",
  null
  
)

export default component.exports